export class AudienceDetails {
    constructor() {
        this.Name = '';
        this.Description = '';
        this.Tags = '';
        this.Properties = '';
        this.AudienceID = 0;
        this.AudienceDetailsID = 0;
        this.IsActive = true;
        this.IsReadOnly = false;
        this.AudienceDetailType = '';
        this.InsertDate = new Date();
        this.UpdateDate = new Date();
        this.CountTotal = 0;
        this.CountUnique = 0;
        this.hasCount = false;
        this.IsGenerating = false;
        this.countsLastRunDate = null;
    }
}
//# sourceMappingURL=AudienceDetails.js.map